import { jsx as _jsx } from "react/jsx-runtime";
import { PromoTag } from '@snack-uikit/promo-tag';
import { TEST_IDS } from '../../constants';
import styles from './styles.module.css';
export function PromoBadge({ text, appearance = 'primary' }) {
    return (_jsx("div", { className: styles.promoBadge, children: _jsx(PromoTag, { appearance: appearance, text: text, "data-test-id": TEST_IDS.promoBadge, className: styles.promoTag }) }));
}
